module.exports = __webpack_public_path__ + "static/media/online_ai.6d459038.png";